<template>
  <div>
    <!-- Desktop Sidebar (Small screens and up) -->
    <v-card class="elevation-2 d-none d-sm-block rounded-lg">
      <v-list class="pa-2">
        <v-list-subheader class="font-weight-bold text-uppercase text-caption text-medium-emphasis mb-2">
          Category
        </v-list-subheader>
        
        <v-list-item
          v-for="category in categories"
          :key="category.id"
          :value="category.id"
          :to="category.path"
          color="primary"
          rounded="lg"
          class="mb-1"
        >
          <template v-slot:prepend>
            <v-icon :icon="category.icon" class="mr-3"></v-icon>
          </template>
          <v-list-item-title class="font-weight-medium">{{ category.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- Mobile Dropdown (Extra small screens) -->
    <div class="d-sm-none mb-2">
      <v-select
        :model-value="activeCategoryPath"
        :items="categories"
        item-title="name"
        item-value="path"
        label="카테고리를 선택하세요"
        variant="outlined"
        density="comfortable"
        color="primary"
        prepend-inner-icon="mdi-menu"
        menu-icon="mdi-chevron-down"
        rounded="xl"
        hide-details
        class="font-weight-bold bg-white"
        @update:model-value="navigate"
      >
        <template v-slot:item="{ props, item }">
          <v-list-item v-bind="props" :prepend-icon="item.raw.icon" :title="item.title"></v-list-item>
        </template>
        <template v-slot:selection="{ item }">
          <div class="d-flex align-center">
            <v-icon :icon="item.raw.icon" size="small" class="mr-2 text-medium-emphasis"></v-icon>
            <span>{{ item.title }}</span>
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import { categories } from '../data/events';

export default {
  name: 'TheSidebar',
  data() {
    return {
      categories: categories
    }
  },
  computed: {
    activeCategoryPath() {
      const path = this.$route.path;
      // 상세 페이지 경로(/csat/1, /csat/2 등)인 경우 /csat으로 고정
      if (path.startsWith('/csat/')) return '/csat';
      return path;
    }
  },
  methods: {
    navigate(path) {
      this.$router.push(path);
    }
  }
}
</script>